import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { MyClientsReSingRespondeModel } from "@app/models/myClientsReSingResponse.model";
import { HelperService } from "@app/services/helper.service";
import { ModalService } from "@app/services/modal.service";
import { SubjectService } from "@app/services/subject.service";
import { DocumentType } from "@models/documentType.model";
import { MyClientsReSignRequestModel } from "@models/myClientsReSignRequest.model";
import { MyClientsService } from "@services/my-clients.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-data-update-tab",
  templateUrl: "./data-update-tab.component.html",
  styleUrls: ["./data-update-tab.component.scss"],
})
export class DataUpdateTabComponent implements OnInit {
  @Output() isActiveQuota: EventEmitter<boolean> = new EventEmitter<boolean>();

  public activeQuota: boolean = false;
  public activeButton: boolean = false;
  public buyerDocument: string;
  public documentTypes: Array<DocumentType>;
  public documentTypesSelector: Array<any> = [];
  public validPattern: boolean = false;
  private dataRequestBuyerReSign: MyClientsReSignRequestModel;

  constructor(
    public helper: HelperService,
    public router: Router,
    public modal: ModalService,
    private myClientService: MyClientsService,
    private spinner: NgxSpinnerService,
    private subjectStore: SubjectService
  ) { 
    this.dataRequestBuyerReSign = new MyClientsReSignRequestModel();
  }

  ngOnInit() {
    this.documentTypes = this.helper.documentTypes;
    this.documentTypes.forEach((item) => {
      this.documentTypesSelector.push({
        ID: item.id,
        VALUE: this.converterToSelect(item.value),
      });
    });
  }

  converterToSelect(value: string): string {
    switch (value) {
      case "CEDULA DE CIUDADANIA":
        return "C.C. CÉDULA DE CIUDADANIA";
      case "CEDULA DE EXTRANJERIA":
        return "C.E. CÉDULA DE EXTRANJERIA";
      case "NIT":
        return "NIT NÚMERO IDENFICACIÓN TRIBUTARIA";
      default:
        return value;
    }
  }

  getDocumentSelector(dataInput) {
    const { document, documentType, patternValid } = dataInput;
    this.validPattern = patternValid;
    this.dataRequestBuyerReSign.documento_comprador = document;
    this.dataRequestBuyerReSign.tipo_documento_comprador = documentType;
  }

  enableButton($event) {
    this.activeButton = $event;
  }

  executeInquiry() {
    this.spinner.show();
    this.setDataStorage();
    this.myClientService.getClientData(this.dataRequestBuyerReSign).subscribe(
      (responseClient: MyClientsReSingRespondeModel) => {
        this.spinner.hide();
        this.isActiveQuota.emit(true);
        this.subjectStore.setClientDataReSign(responseClient);
      },
      (error:any) => {
        this.spinner.hide();
        this.showModalWithError();
      }
    )
  }

  showModalWithError() {
    this.modal.show("generalTemplate", {
      title: "¡Lo sentimos!",
      icon: "icon-error.svg",
      mainSubtitle: "Su comprador presenta una novedad en su cupo, por favor comuníquese a nuestro centro de experiencia PBX:",
      secondarySubtitle: "Línea nacional: 018000-946-969 <br> Línea en Bogotá: (601) 353 43 24",
      buttonName: "Aceptar"
    });
  }

  setDataStorage() {
    const dataUserStorage = JSON.parse(sessionStorage.getItem('user'));
    this.dataRequestBuyerReSign.documento = dataUserStorage.userInfo.DOCUMENTO;
    this.dataRequestBuyerReSign.tipo_documento = dataUserStorage.userInfo.TIPO_DOCUMENTO;
  }

}